'use client'

// src/hooks/addons.ts
import { useEffect, useState } from "react";
var useAddonsPosition = ({ groupIds }) => {
  const [activeId, setActiveId] = useState(groupIds[0]);
  useEffect(() => {
    const checkVisibility = () => {
      const sectionElements = groupIds.map((id) => document.getElementById(id)).filter((el) => !!el);
      let maxVisibleArea = 0;
      let mostVisibleId;
      sectionElements.forEach((element) => {
        if (element) {
          const rect = element.getBoundingClientRect();
          const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
          const visibleHeight = Math.min(rect.bottom, viewHeight) - Math.max(rect.top, 0);
          const visibleArea = visibleHeight * rect.width;
          if (visibleArea > maxVisibleArea) {
            maxVisibleArea = visibleArea;
            mostVisibleId = element.id;
          }
        }
      });
      if (mostVisibleId && mostVisibleId !== activeId) {
        setActiveId(mostVisibleId);
      }
    };
    window.addEventListener("scroll", checkVisibility);
    checkVisibility();
    return () => {
      window.removeEventListener("scroll", checkVisibility);
    };
  }, [activeId, groupIds]);
  return { activeId, setActiveId };
};
var addons_default = useAddonsPosition;

export {
  addons_default
};
//# sourceMappingURL=chunk-SBVHDSIP.mjs.map